import { AnimatedNumber } from "./AnimatedNumber";

type PriceLabelProps = {
  price?: number;
};

export const PriceLabel = ({ price }: PriceLabelProps) => {
  return (
    <div className="core-calculator-price">
      {!!Number(price) && (
        <>
          <span className="core-calculator-price__int">
            $ <AnimatedNumber number={Math.floor(Number(price))} />
          </span>
          <span className="core-calculator-price__dec">
            <AnimatedNumber number={Number(price) * 100 - Math.floor(Number(price)) * 100} showZeros />
          </span>
        </>
      )}
    </div>
  );
};
